export default {
  dynamics: '{{change}} t.o.v. vorige week',
};
